module.exports = __webpack_public_path__ + "static/media/stock-1.5843dac3.jpg";